var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignIn1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.8 86.8",
    style: {
      enableBackground: "new 0 0 86.8 86.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:#4ADE80;enable-background:new    ;}\n\t.st1{fill:#4ADE80;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,0C19.4,0,0,19.4,0,43.4s19.4,43.4,43.4,43.4s43.4-19.4,43.4-43.4l0,0C86.8,19.4,67.4,0,43.4,0z  M63.6,64.6H23.2V57c0-3.6,1.6-7,4.4-9.3c2.5-1.9,5.3-3.4,8.4-4.2c-5.2-4.1-6-11.6-1.9-16.8s11.6-6,16.8-1.9s6,11.6,1.9,16.8 c-0.6,0.7-1.2,1.4-1.9,1.9c3,0.9,5.9,2.3,8.4,4.3l0,0c2.8,2.2,4.4,5.6,4.4,9.2V64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.2,50.2c-2.6-2-5.5-3.4-8.7-4.1H38.2c-3.2,0.7-6.1,2.1-8.7,4.1c-2.1,1.6-3.3,4.1-3.3,6.8v4.4h34.2V57 C60.5,54.4,59.3,51.9,57.2,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.4,43L43.4,43c4.9,0,8.8-4,8.8-8.8c0-4.9-4-8.8-8.8-8.8s-8.8,4-8.8,8.8C34.6,39.1,38.5,43,43.4,43z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn1);
export default __webpack_public_path__ + "static/media/sign-in (1).14a3c4717c15454e57cd01c4c8ff4b56.svg";
export { ForwardRef as ReactComponent };